module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG6d6b11e2cd3005ee53817234239218f6.6d6b11e2.png";